
import { Typography } from '@mui/material';
import { useApp } from '../../context/AppContext';
import Linkify from 'linkify-react';
import '../../assets/style/SupportTickets.css';

export default function ReplyCard({ reply }) {
  const { user } = useApp();

  // Форматируем дату
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        month: 'numeric',
        day: 'numeric', 
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
      });
    } catch (error) {
      console.log('Error formatting date:', error);
      return dateString || '';
    }
  };

  // Получаем имя автора
  const getAuthorName = () => {
    // Если сообщение от клиента, показываем email пользователя
    if (reply.from === 'client' || reply.author_name === 'client') {
      // Если email пользователя загружен, показываем его
      if (user?.email) {
        return user.email;
      }
      // Если есть author_name в сообщении и это не "client", используем его
      if (reply.author_name && reply.author_name !== 'client') {
        return reply.author_name;
      }
      // Иначе показываем "client"
      return 'client';
    }
    
    // Если есть конкретное имя автора, используем его
    if (reply.author_name) return reply.author_name;
    if (reply.author) return reply.author;
    if (reply.from) return reply.from;
    
    return 'Unknown';
  };

  // Получаем контент сообщения
  const getContent = () => {
    if (reply.content) return reply.content;
    if (reply.message) return reply.message;
    if (reply.text) return reply.text;
    return 'No content';
  };

  return (
    <div className="reply-card">
      <div className="reply-header">
        <Typography className="reply-author">
          {getAuthorName()}
        </Typography>
        <Typography className="reply-timestamp">
          {formatDate(reply.created_at || reply.timestamp || reply.date)}
        </Typography>
      </div>

      <Typography className="reply-body">
        <div
          dangerouslySetInnerHTML={{
            __html: getContent(),
          }}
        />
      </Typography>
    </div>
  );
}